import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card';
import { GetPersonlListWithPayrol } from '../../../../store/HR/Payroll/runPayrollSlice';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import NtxTable from '../../../../components/DataTable/NtxTable';
import ModalComponent from '@components/Modal/ModalComponent';
import ElementEntry from './ElementEntry';
import AddPayProposal from '../PayProposal/AddPayProposal';

const PayrollElementEntry = () => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [personData, setPersonData] = useState();

  const { PersonlListWithPayrol, loading, error } = useSelector(state => state.runPayroll);

  useEffect(() => {
    if (PersonlListWithPayrol?.length === 0) {
      dispatch(GetPersonlListWithPayrol());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const columns = [
    { title: t('Employee'), key: 'Employee' },
    // { title: t('Employe  eName'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'EmployeeNumber' },
    { title: t('Payroll'), key: 'Payroll' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = PersonlListWithPayrol?.map(emp => {
    // let rowClass;
    const {
      assignmentId,
      employeeNumber,
      personName2,
      personName,
      payrollName,
      payrollName2,
      payrollId
    } = emp;

    return {
      Employee: (
        <div className='d-flex align-items-center gap-2'>
          <img
            src={emp.photoUrl || '../../../assets/img/user/manEmp.png'}
            alt='Employee'
            className='rounded-circle'
            style={{ width: '40px', height: '40px', objectFit: 'cover' }}
          />
          <span>{i18n.language === 'ar' ? personName2 : personName}</span>
        </div>
      ),
      // Name: i18n.language === 'ar' ? personName2 : personName,
      EmployeeNumber: employeeNumber,
      Payroll: i18n.language === 'ar' ? payrollName2 : payrollName,
      action: (
        <div className='btn-group'>
          {HasPermission('PayAssignmentBasicSalary') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme mx-1'
              data-bs-toggle='modal'
              data-bs-target='#BasicSalary'
              onClick={() => setPersonData(emp)}
            >
              <i className=' fs-4 bi-cash fa-lg me-2'></i>
              {t('Basic_salary')}
            </button>
          )}

          {HasPermission('PayAssignmentPayrollElementEntries') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme mx-1 '
              onClick={() =>
                Navigate(`${assignmentId}/${payrollId}/AddElementEntry`, {
                  state: {
                    ReferenceName: i18n.language === 'en' ? personName : personName2,
                    PayrollName: i18n.language === 'en' ? payrollName : payrollName2
                  }
                })
              }
            >
              <i className='bi-journal-text fa-lg me-1'></i>
              {t('PayrollElementEntry')}
            </button>
          )}
        </div>
      )
    };
  });

  //_____________________

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },

    {
      name: t('PayrollElementEntry'),
      link: null
    }
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('PayrollElementEntry')} />

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id={'BasicSalary'} title={t('Basic_salary')}>
        {personData && <AddPayProposal personData={personData} />}
      </ModalComponent>
    </>
  );
};

export default PayrollElementEntry;
